<template>
  <b-modal v-model="visible" size="lg" centered scrollable no-close-on-backdrop header-class="bg-modal-header">

    <template #modal-header>
      <div class="fw-bold">충전기 오류 상세</div>
    </template>

    <div class="row">
      <div class="col-xl-12">
        <div class="card mb-0">
          <div class="card-body pb-0">
            <div class="dashboard-error-modal-table">
              <b-table class="datatables text-nowrap" :fields="fields" :items="items">
                <template #cell(placeName)="data">
                  <span :title="`${data.item.placeName}`">{{ $_utils.textLengthOverCut(data.item.placeName, 15, '') }}</span>
                </template>
                <template #cell(startTime)="data">
                  {{ $_utils.changeDateFormat(data.item.startTime, 'MM-DD HH:mm:ss') }}
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template #modal-footer>
      <div class="w-100">
        <b-button variant="secondary" class="float-end w-xs p-1" @click="visible=false">닫기</b-button>
      </div>
    </template>

  </b-modal>
</template>

<script>
import { http } from '@/mdk/auth-api';

export default {
  data() {
    return {
      visible: false,
      fields: [
        { key: 'placeName', label: '충전소', class: 'text-center' },
        { key: 'csoEvseNum', label: '충전기', class: 'text-center' },
        { key: 'errorCode', label: '오류 코드', class: 'text-center' },
        { key: 'diffTime', label: '지속 시간' },
        { key: 'firstNotiTime', label: '상태 확인', class: 'text-center' }
      ],
      items: []
    }
  },
  methods: {
    show() {
      const vm = this;

      vm.getItems();
      vm.visible = true;
    },
    getItems() {
      const vm = this;
      const _url = '/onmapi/dashboard/failure-detail';

      http.get(_url)
          .then((res) => {
            vm.items = res.data.items;
          })
          .catch(err => {
            console.error('Failure Detail Data Error :: ', err)
          });
    }
  }
}
</script>
